import Vue from 'vue';
import _ from 'lodash';
import TheDesign from '@/layouts/TheDesign';
import MENU_ITEMS from '@/constants/design/DESIGN_MENU_ITEMS';

const requireComponent = require.context('../views/design', true, /\.vue$/);

requireComponent.keys().forEach(fileName => {
  const component = requireComponent(fileName).default;
  Vue.component(component.name, component);
});

const menuIdToComponentId = menuId =>
  _.chain(menuId)
    .camelCase()
    .upperFirst()
    .value();

const designRoutes = _.chain(MENU_ITEMS)
  .map(menu => {
    const componentId = menuIdToComponentId(menu.id);
    const component = Vue.component(menu.component || componentId);
    if (!component) return null;

    return {
      path: menu.path,
      meta: { menuItemId: menu.id },
      component
    };
  })
  .compact()
  .value();

export default [
  {
    path: '/design',
    component: TheDesign,
    children: designRoutes
  }
];
